import {
  config,
  INDEXEDDB,
  WEBSQL,
  LOCALSTORAGE,
  getItem,
  setItem,
  removeItem,
  keys,
  clear,
} from 'localforage';

export class StorageService {
  private initialized = false;

  initialize() {
    if (!this.initialized) {
      return;
    }
    config({
      driver: [INDEXEDDB, WEBSQL, LOCALSTORAGE],
      name: 'storage',
      version: 1.0,
      storeName: 'Storage',
      description: '',
    });
    this.initialized = true;
  }
  getItem<T>(key: string): Promise<T | null> {
    this.initialize();
    return getItem<T>(key);
  }
  getItems<T>(keys: string[]): Promise<(Awaited<T> | null)[]> {
    this.initialize();
    const promises = keys.map((item) => {
      return getItem<T>(item);
    });

    return Promise.all(promises);
  }
  setItem<T>(key: string, data: T): Promise<T> {
    this.initialize();
    return setItem<T>(key, data);
  }
  removeItem(key: string): Promise<void> {
    this.initialize();
    return removeItem(key);
  }
  keys(): Promise<string[]> {
    this.initialize();
    return keys();
  }
  clear(): Promise<void> {
    this.initialize();
    return clear();
  }
}

export class MockStorageService {
  private store: Record<string, unknown>;

  constructor() {
    this.store = {};
  }

  async clear(): Promise<void> {
    this.store = {};
  }

  async getItem<T>(key: string): Promise<T | null> {
    return (this.store[key] as T) ?? null;
  }

  async getItems<T>(keys: string[]): Promise<(T | null)[]> {
    const promises = keys.map((key) => this.getItem<T>(key));
    return Promise.all(promises);
  }

  async setItem<T>(key: string, data: T): Promise<void> {
    this.store[key] = data;
  }

  async removeItem(key: string): Promise<void> {
    delete this.store[key];
  }

  async keys(): Promise<string[]> {
    return Object.keys(this.store);
  }
}

export const storage = (() => {
  if (typeof window === 'undefined') {
    return new MockStorageService();
  }
  if (process.env['NODE_ENV'] === 'test') {
    return new MockStorageService();
  }
  return new StorageService();
})();
